import { DataHeader, DataSource, Layout, SearchPanel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierCallinHistoryList extends Layout {
    dataheaderSearchCarrierCallin: DataHeader;
    searchpanelCallinHistory: SearchPanel;
    sourceCarrierCallinHistory: DataSource;
    tableCarrierCallinHist: Table;
    textboxCallDateTime: Textbox;
    textboxCallinType: Textbox;
    textboxCarrierId: Textbox;
    textboxScriptTemplate: Textbox;
    textboxSearchCallinStatus: Textbox;
    textboxSearchEnteredBy: Textbox;
    textboxorderId: Textbox;
}
